import { render, staticRenderFns } from "./TicketPending.vue?vue&type=template&id=6ba1e111&scoped=true&"
import script from "./TicketPending.vue?vue&type=script&lang=js&"
export * from "./TicketPending.vue?vue&type=script&lang=js&"
import style0 from "./TicketPending.vue?vue&type=style&index=0&id=6ba1e111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba1e111",
  null
  
)

export default component.exports